import React from 'react';
import styled from '@emotion/styled';

interface Props {
  dark?: boolean;
  children?: React.ReactNode;
}

const Component = styled.table<{
  dark?: boolean;
}>`
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  background-color: ${(props) => (props.dark ? 'var(--colorBlueGray1000)' : '#fff')};
`;

const Table: React.FC<Props> = ({ dark, children }) => {
  return <Component dark={dark}>{children}</Component>;
};

export default Table;
